const zh = {
    titles: {
        shortCut: "快捷方式",
        equipmentPair: "设备配对",
        deviceWifi: "设备上网",
        gatewayControllerDetail: "网关设备详情",
        productGuidance: "使用指导",
        flashQuery: "闪光配置查询",
        privacyPolicy: "隐私策略",
        privacy: "隐私政策",
        useAgreement: "使用协议",
        illustrate: "使用说明"
    },
    default: {
        create: "创建",
        prompt: "提示",
        delete: "删除",
        confirm: "确定",
        complete: "完成",
        save: "保存",
        cancel: "取消",
        Cancel: "取消",
        open: "开启",
        noOpen: "不开启",
        msgA: "请输入手机号码",
        phoneError: "手机号格式错误",
        msgB: "请输入姓名",
        msgC: "操作成功",
        msgD: "删除成功",
        msgE: "转让成功",
        msgF: "修改成功",
        msgG: "添加成功",
        msgH: "保存成功",
        msgI: "创建成功",
        msgError: "出了点小状况",
        noMore: "没有更多了",
        newVersionNotice: "请升级版本",
        notSupportEmoji: "该输入框不支持表情输入",
        loadingText: "加载中...",
        searchText: "请输入搜索关键词",
    },
    shortCut: {
        text1: "为什么点击添加到桌面后，桌面上找不到图标：",
        text2: "部分用户在闪易客户端页面内点击“添加到桌面”后，并未在手机桌面上找到对应的图标，\n" +
            "原因在于闪易内“添加到桌面”功能被系统关闭。请前往系统设置中为闪易打开“创建桌面快捷方式”开关，开关开启后，请返回闪易重新点击“添加到桌面”。",
        text3: "主要机型及其打开方式：",
        text4: "华为：",
        text5: "方式1：设置--应用和通知--权限管理--权限--创建桌面快捷方式--闪易",
        text6: "方式2：设置--应用和通知--应用管理--闪易--权限--设置单项权限--创建桌面快捷方式",
        text7: "方式3：手机管家--权限管理--权限--创建桌面快捷方式--闪易",
        text8: "方式1：设置--安全--应用权限--权限--创建桌面快捷方式--闪易",
        text9: "方式2：手机管家--权限隐私--应用权限管理--权限--创建桌面快捷方式--闪易",
        text10: "方式1：设置--更多设置--权限管理--权限--桌面快捷方式--闪易",
        text11: "方式2：i管家--应用管理--权限管理--桌面快捷方式--闪易",
        text12: "小米：",
        text13: "方式1：设置--授权管理--应用权限管理--权限管理--桌面快捷方式--闪易",
        text14: "方式2：安全中心--应用管理--权限--应用权限管理--权限管理--桌面快捷方式--闪易",
        text15: "如何在闪易里打开“创建桌面快捷方式”开关（以华为为例）",
        text16: "1、打开“设置”",
        text17: "2、进入“应用”",
        text18: "3、进入“权限管理”",
        text19: "4、点击权限，滑动屏幕，找到“创建桌面快捷方式”",
        text20: "5、进入“创建桌面快捷方式”，找到“闪易”，打开开关",
        text21: "6、重新回到闪易客户端内，选择“添加到桌面”",
    },
    equipmentPair: {

        gatewayController: "网关设备",
        clientDevice: "终端设备",
        searchTitle: "搜索设备",
        searchTypeAll: "全部",
        searchTypeController: "集中器",
        enterSN: "输入SN码",
        scaleQRCode: "扫描设备码",
        deviceDate: "时间",
        deviceName: "名称",
        deviceEdit: "编辑",
        edit: "编辑",
        noMoreData: "没有更多了",
        cancel: "取消",
        editDel: "删除",
        delete: "删除",
        confirm: "确认",
        enterDeviceInfo: "请输入设备信息",
        tipEnterSN: "请输入SN号",
        tipEnterSecurityCode: "请输入安全码",
        tipEnter4PlaceSecurityCode: "请输入4位安全码",
        scaleQRCodeTitle: "扫设备二维码",

        sn: "SN号",
        deviceLock: "门锁",
        deviceSensor: "取电感应器",
        noPairedClickedDetails: "未进入配对状态，点击查看详情",
        deviceVersion: "硬件版本号",
        softwareVersion: "软件版本",
        stopPair: "结束配对",
        startPair: "开始配对",
        statusNoPaired: "未配对",
        statusWaitingToPair: "等待配对",
        statusPairing: "配对中",
        statusPairFailed: "配对失败",
        statusPairSuccessed: "已配对",
        statusBinded: "已绑定",
        deviceBindedNoAllowedToOperate: "当前设备已绑定，不可在设备配对中操作",
        devicePairingTip: "正在配对当前设备，门锁可在唤醒后依次按“0”“#”快速配对",
        addClientDevice: "添加终端设备",
        deviceNumberOver: "（可添加数量已满）",
        deviceOwned: "现有终端设备",
        pairingPromptText1: "请确保已设置网络并正常连接网络，正常连接网络时蓝色指示灯常亮。",
        pairingPromptText2: "在已正常连接网络情况下，请短按一下配网按键，快速进入配对模式，或等待集中器自动进入配对模式，进入配对模式时蓝色指示灯以短亮长灭模式闪烁。",
        enterClientInfo: "请输入终端设备信息",
        tipEnterName: "请输入名称",
        clientNameTitle: "终端设备名称",
        tipEnterClientName: "请输入终端设备名称",
        deleteGatewayControllerPromptTitle: "是否确定删除该网关设备？",
        deleteGatewayControllerPromptTip: "提示：删除同时会删除对应的终端设备",
        manage: "管理",
        successTip: "操作成功！",
        addClientTip: "请选择需要添加的终端设备",
        deleteClientPromptTitle: "是否确定删除勾选的终端设备？",
        deviceDefaultName: "我的设备",
        clientDevicesList: "终端设备列表"

    },
    flashQuery: {
        inputUserPhone: "输入用户手机号",
        query: "查询",
        modelInfo: "机型信息",
        modelPhone: "手机型号",
        androidVersion: "Android版本",
        listStatus: "黑白名单状态",
        recentUse: "最近使用",
        params: "可调参数",
        flashMode: "闪光模式",
        delayTime: "延迟时间",
        switchScreen: "开关截屏",
        cancel: "取消",
        saveSet: "保存配置",
        useMoreSelect: "该用户使用过多款机型，请选择",
        currentSet: "当前配置",
        currentDelay: "当前延迟时间",
        currentNotSupport: "当前系统暂不支持该选项",
        blackList: "黑名单",
        whiteList: "白名单",
        notSet: "未设置",
        notSelectFlash: "未选择闪光模式",
        setSuccess: "设置成功"
    },
    ad: {
        privacyPolicy: "隐私策略",
        update: "我们的隐私政策已于2021 年 11 月 11日更新！",
        row1: "我们对隐私政策进行了修订，从该日期开始， 这一隐私政策能够提供有关我们如何管理您在使用所有闪易产品和服务时透露的个人信息的隐私详情，除了特定的闪易产品或服务提供独立的隐私政策以外。",
        row2: "请花一些时间熟悉我们的隐私权惯例，如果您有任何问题，请告诉我们。我们向您承诺本隐私政策规定了闪易科技有限公司（下文简称“闪易”或“我们”）如何收集、使用、披露、处理和保护您在使用我们的产品和服务时通过我们在移动设备上提供的应用程序套装提供给我们的信息。若我们要求您提供某些信息，以便在使用闪易产品和服务时验证您的身份，我们将仅严格遵守本隐私政策或我们的用户条款与条件来使用这些信息。",
        row3: "本隐私政策在制定时充分考虑到您的需求；您全面了解我们的个人资料收集和使用惯例而且确信自己最终能控制提供给闪易的个人信息，这一点至关重要。",
        row4: "在这项隐私政策中，“个人信息”指信息本身或与闪易能够访问的个人的其他信息联系后能够识别特定个人的数据。此类个人信息包括您的姓名、地址、电话号码和电子邮箱地址。",
        row5: "通过使用闪易产品和服务，即表示您已阅读、认可并接受本隐私政策中所述之所有条款，包括我们随时作出的任何变更。",
        row6: "我们承诺遵照适用法律（包括您所在地的数据保护法律）来保护您的个人信息的隐私、机密和安全。最后，我们所希望的就是为我们的用户带来最好的体验。",
        howUse: "收集哪些信息以及如何使用信息？",
        collectInfo: "收集的信息类别",
        row7: "为了向您提供我们的服务，我们会要求您提供向您提供服务所必需的个人信息。如果您不提供个人信息，我们可能无法向您提供我们的产品或服务。",
        collectKindsInfo: "我们收集以下各类信息（无论其是否为个人信息）：",
        row8: "您上传或提供给我们的信息（包括您的联系方式）：我们可能会采集您提供给我们的任意/所有个人信息，微信账号详细信息（例如，您的用户名、头像），闪易账号详细信息，与创建账号、使用闪易平台和提交反馈意见相关的信息，以及任何其他您主动提交给我们的信息，例如您的手机号、邮箱地址、微信号。",
        row9: "我们指定的与您相关的信息：我们可能收集并使用诸如微信账号、闪易账号等信息。",
        row10: "您提交的反馈信息：如果您向我们提交使用中遇到的问题，我们会将您提交的问题保存在服务器，用于改善产品。",
        howUserInfo: "这些个人信息将会被如何使用",
        row11: "收集个人信息的目的在于向您提供产品和/或服务，并且保证我们遵守适用法律。您特此同意我们出于本隐私政策规定的目的处理个人信息，并向我们的关联公司（其涉及通信、社交媒体、技术和云业务）、第三方服务供应商（定义如下）披露个人信息。",
        useThis: "我们可能会将您的个人信息用于下列目的：",
        row12: "提供、处理、维护、改善、开发我们的商品和/或提供给您的服务，包括售后服务和客户支持，以及通过设备或网站提供的服务",
        row13: "与您就您的设备、服务或任何普通查询（例如更新、客户咨询支持、我们活动的相关信息、通知）等进行交流。",
        row14: "在通过网站或移动设备创建闪易账号时收集的个人信息用于建立用户的个人账户和资料页。",
        row15: "收集用户反馈。您选择提供的反馈对帮助闪易改进我们的服务而言极为珍贵。为了跟踪您选择提供的反馈，闪易可能会使用您所提供的个人信息与您联系，并保留记录。",
        directPro: "直接推广",
        row16: "我们可能会使用您的姓名、电话号码、电子邮箱地址、微信账号、闪易账号、IMEI号码向您提供闪易公司及其合作伙伴（提供网络、移动应用程序和云产品和服务）的产品和服务相关的推广资料。为了提供更好的用户体验，我们会根据您的购买历史、网站浏览历史、生日、年龄、性别和地理位置等信息推荐上述产品、服务和活动。我们严格遵守您所在地的数据保护法，要求独立的明确许可，所以我们只会在征得您的同意或您表示不反对时使用您的个人信息。您有权终止我们使用计划用于直接推广的个人数据。",
        row40: "我们会收集您的软件安装列表信息，用于判断是否可以提供快速登录（如微信号登录）和绑定免密支付（支付宝免密支付、微信免密支付）功能",
        row41: "我们会获取您的IMEI号、MAC地址，来判断您是否异地登录",
        row42: "我们会获取您的设备序列号，硬件名称、硬件ID、手机品牌，来配置闪光必要的摄像机调整参数",
        cookieUse: "Cookie和其他技术(只在浏览www.shinyeasy.com时)",
        row17: "收集哪些信息以及如何使用这些信息？闪易和第三方服务供应商使用 cookie、标签和脚本等技术。这些技术用于分析趋势、管理网站、追踪用户的网站活动并收集关于整个用户群的人口统计信息。我们会收到这些公司基于使用上述技术的单独和汇总报告。",
        row18: "日志文件：和大部分网站一样，我们收集特定信息并保存在日志文件中。此类信息可能包括互联网协议 (IP) 地址、浏览器类型、互联网服务供应商 (ISP)、引用/退出页面、操作系统、日期/时间戳和点击流数据。 我们不会将自动收集的数据链接到我们收集的关于您的其他信息之中。",
        row19: "广告：我们与第三方服务供应商合作，在我们的网站上展示广告或管理我们在其他网站上的广告。我们的第三方服务供应商可能会使用诸如 cookie 等技术来收集您在其网站或其他网站上的活动信息，以根据您的浏览活动和兴趣为您提供广告。如果不希望该信息被用于根据您的兴趣投放广告，可以点击此处选择退出。",
        row20: "移动分析：在某些移动应用中，我们使用移动分析软件，以更好地了解我们的移动软件在您的手机中的功能。此款软件可能记录以下信息，如您使用该应用程序的频率、该应用程序内发生的事件、累计使用、性能数据及应用程序崩溃发生的位置。我们不会将存储于分析软件内的信息链接到您在移动应用程序中提交的任何个人信息。",
        row21: "本地存储 – HTML5/Flash：我们使用本地存储对象 (LSO)，例如 HTML5 或 Flash 存储内容和偏好。根据您的网页浏览行为，与我们合作在网站上提供某些功能或投放广告的第三方也会通过 HTML5 或 Flash cookie 来收集和存储相关信息。各种浏览器提供了各自的管理工具来删除 HTML5 本地存储对象。要管理 Flash cookie，请点击这里：",
        jump: "跳转",
        shareInfo: "我们与谁共享您的信息？",
        row22: "我们不会将任何个人信息出售给第三方。我们有时可能会向第三方（定义见下文）披露您的个人信息，以便提供您要求的产品或服务。",
        row23: "我们可能会向本部分下文列出的第三方服务供应商和关联公司作出披露。在本部分所述的各种情况下，您可以放心，闪易仅会根据您的授权共享您的个人信息。您应当了解，在下文描述的任何情况下，当闪易与第三方服务供应商共享您的个人信息时，闪易会通过合同规定第三方的实践和义务，遵守适用的地方数据保护法。闪易会通过合同保证第三方服务供应商遵守您所属司法管辖区中适用于他们的隐私权标准。",
        shareOther: "与我们集团和第三方服务供应商共享信息",
        row24: "为了顺利地从事商业经营，以向您提供产品和服务的全部功能，我们可能不时向其他的闪易关联公司（其涉及通讯、社交媒体、技术或云业务）或我们的第三方服务供应商（我们的邮寄商店、送货服务供应商、电信公司、数据中心、数据存储设施、客户服务供应商、广告和推广服务供应商、代表闪易的代理）[关联公司和/或其他第三方]（统称为“第三方服务供应商”）披露您的个人信息。此类第三方服务供应商可能代表闪易或出于上述的一项或多项目的处理您的个人信息。在我们的设备上使用某些移动应用程序时，我们可能会和第三方共享您的 IP 地址，以便为您提供您要求的某些服务。",
        yueCan: "您能做什么！",
        row25: "您可以通过不向任何人（除非此人经您正式授权）披露您的登录密码或账户信息，为保护您个人信息的安全发挥作用。无论您何时作为微信账号用户登录闪易产品，尤其是在他人的计算机或公共互联网终端上登录时，在会话结束时您总应注销登出。",
        row26: "闪易不对因您未能保持个人信息的私密性而导致第三方访问您的个人信息进而造成的安全疏漏承担责任。尽管有上述规定，如果发生互联网其他任何用户未经授权使用您账户的情况或其他任何安全漏洞，您必须立即通知我们。",
        row27: "您的协助将有助于我们保护您个人信息的私密性。",
        retentionPolicy: "保留政策",
        row28: "如有必要实现收集信息的目的，或者遵守适用法律要求或允许，我们将一直保留个人信息。只要能够合理推断保留个人信息不能实现收集个人信息的目的，并且出于法律、解决纠纷、强制实施我们的协议或其他商业目的不再需要保留信息时，我们将不再保留个人信息，或者会消除将个人信息和特定个人关联起来的途径。",
        row29: "访问您的设备上的其他功能，我们的应用程序可能会访问您设备上的某些功能，例如启用联系人、短信存储和 Wi-Fi 网络状态，以及其他功能。这些信息用于允许这些应用程序在您的设备上运行，并且允许您与其互动。在任何时候，您可以通过在设备水平上关闭应用程序撤销许可",
        controlSet: "控制设置",
        row30: "闪易承认每个人对隐私权的关注各不相同。因此，我们提供了一些示例，说明闪易提供的各种方式，供您选择，以限制收集、使用、披露或处理您的个人信息，并控制您的隐私权设置：",
        row31: "登入或登出闪易账户；",
        row32: "同意或取消同意用户协议和隐私条款。",
        row33: "您有权要求访问和/或更正我们持有的与您有关的任何个人信息。当您更新个人信息时，在我们处理您的请求前，会要求验证您的身份。一旦我们获得充分信息，可处理您的请求以访问或更正您的个人信息时，我们将在适用数据保护法规定的时间内对您的请求做出回应。",
        transfer: "将个人信息转移到您所属的司法管辖区之外",
        row34: "如果我们需要将个人信息转移到您所属的司法管辖区之外，无论是转移给我们的关联公司（其涉及通信、社交媒体、技术和云业务）或第三方服务供应商时，我们将按照适用法律进行。特别是，我们通过落实合适的安全保障措施，保证所有这类转移满足适用的地方数据保护法的要求。",
        priority: "优先顺序",
        row35: "如果您同意了适用的用户协议，并且此类用户协议和本隐私政策之间存在不一致，将以此类用户协议为准。",
        agreeThird: "我是否必须同意任何第三方条款与条件？",
        row36: "我们的隐私政策不适用于第三方提供的产品和服务。闪易产品和服务可能包括第三方的产品和服务，以及第三方网站的链接。当您使用这些产品或服务时，也可能收集您的信息。因此，我们强烈建议您花时间阅读该第三方的隐私政策，就像阅读我们的政策一样。我们不对第三方如何使用他们向您收集的个人信息负责，也不能控制其使用。我们的隐私政策不适用通过我们的服务链接的其他网站。",
        contactUs: "联系我们",
        row37: "如果您对本隐私政策有任何意见或问题，或者您对闪易收集、使用或披露您的个人信息有任何问题，请通过下列地址联系我们，并提及“隐私政策 ”：",
        shinyeasyCom: "杭州闪易科技有限公司",
        addr: "杭州市余杭区五常街道未来科技城海创园19幢706",
        tel: "电话：0571-86811305",
        thanks: "感谢您花时间了解我们的隐私政策！",
        thridSdk: "第三方SDK信息",
        jg: "极光SDK",
        permissions: "获取权限：",
        jgp1: "*获取您的设备信息",
        jgp2: "*获取您的手机号码",
        jgp3: "*获取您的地理位置",
        jgp4: "*获取您的网络信息",
        purpose: "使用目的：",
        jgp5: "*推送消息",
        jgp6: "*帮助用户实现一键登陆",
        jgpu: "极光隐私协议：",
        baidup: "百度隐私协议：",
        baiduOCR: "百度文字识别OCR",
        bd1: "*获取您的身份证上的文字信息",
        bd2: "*实名认证",
        baiduFace: "百度人脸识别SDK",
        bd3: "*获取您的面部生物识别信息",
        bd4: "*活体校验所必要的信息",
        baiduStatistical: "百度移动统计SDK",
        bd5: "*获取您的设备信息,手机IMEI、MAC地址、DEVICEID、AndroidID、已安装包名列表、已安装软件软件列表",
        bd6: "*获取您的硬件读写权限",
        bd7: "*统计新用户和用户使用",
        bd8: "*统计app内日志信息",
        bd9: "备注：为保证用户画像属性及用户细分行为，使用过程中会将用户的IMEI等信息传输至“dxp.baidu.com”",
    },
    agreement: {
        Urow1: "欢迎您使用闪易APP软件及服务！",
        Urow2: "为使用闪易APP软件（以下简称“本软件”）及服务，您应当阅读并遵守《闪易APP软件许可及服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。 除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用本软件及相关服务。您的下载、安装、使用、获取闪易APP帐号、登录等行为即视为您已阅读并同意上述协议的约束。如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。",
        scope: "一、协议的范围",
        mainScope: "1.1 协议适用主体范围",
        Urow3: "本协议是您与闪易之间关于您下载、安装、使用、复制本软件，以及使用闪易相关服务所订立的协议。",
        agreeRelation: "1.2 协议关系及冲突条款",
        Urow4: "本协议被视为《闪易支付服务用户协议》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。本协议内容同时包括闪易科技可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。",
        aboutService: "二、关于本服务",
        serviceContent: "2.1 本服务的内容",
        Urow5: "本服务内容是指闪易向用户提供的更加安全快速的光交互和光支付功能（以下简称“闪易”）。通过手机闪光灯的轻轻一闪，即可一闪支付、一闪开门、一闪点餐、一闪乘车等功能或内容的软件许可及服务（以下简称“本服务”）。",
        serviceForm: "2.2 本服务的形式",
        Urow6: "2.2.1 您使用本服务需要下载闪易客户端软件，对于这些软件，闪易给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件及服务。",
        Urow7: "2.2.2 本服务中闪易客户端软件提供包括但不限于iOS、Android多个应用版本，用户必须选择与所安装终端设备相匹配的软件版本。",
        licenseScope: "2.3 本服务许可的范围",
        Urow8: "2.3.1 闪易给予您一项个人的、不可转让及非排他性的许可，以使用本软件。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。",
        Urow9: "2.3.2 您可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。",
        Urow10: "2.3.3 本条及本协议其他条款未明示授权的其他一切权利仍由闪易保留，您在行使这些权利时须另外取得闪易的书面许可。闪易如果未行使前述任何权利，并不构成对该权利的放弃。",
        getSoftware: "三、软件的获取",
        Urow11: "3.1 您可以直接从闪易的网站上获取本软件，也可以从得到闪易授权的第三方获取。",
        Urow12: "3.2 如果您从未经闪易授权的第三方获取本软件或与本软件名称相同的安装程序，闪易无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。",
        installAndUnInstall: "四、软件的安装与卸载",
        Urow13: "4.1 闪易可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。",
        Urow14: "4.2 下载安装程序后，您需要按照该程序提示的步骤正确安装。",
        Urow15: "4.3 为提供更加优质、安全的服务，在本软件安装时闪易可能推荐您安装其他软件，您可以选择安装或不安装。",
        Urow16: "4.4 如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助闪易改进产品服务，请告知卸载的原因。",
        softwareUpdate: "五、软件的更新",
        Urow17: "5.1 为了改善用户体验、完善服务内容，闪易将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。",
        Urow18: "5.2 为了保证本软件及服务的安全性和功能的一致性，闪易有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。",
        Urow19: "5.3 本软件新版本发布后，旧版本的软件可能无法使用。闪易不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。",
        infoProtect: "六、用户个人信息保护",
        Urow20: "6.1 保护用户个人信息是闪易的一项基本原则，闪易将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可闪易不会向第三方公开、透露用户个人信息。闪易对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。",
        Urow21: "6.2 您在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供帐号注册服务或进行用户身份识别，需要您填写手机号码；附近的人功能需要您同意使用您所在的地理位置信息；手机通讯录匹配功能需要您授权访问手机通讯录等。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。",
        Urow22: "6.3 一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。",
        Urow23: "6.4 闪易将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。",
        Urow24: "6.5 未经您的同意，闪易不会向闪易以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。",
        Urow25: "6.6 闪易非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用闪易的服务前，应事先取得您家长或法定监护人的书面同意。",
        mainSovereign: "七、主权利义务条款",
        userSpe: "7.1 帐号使用规范",
        Urow26: "7.1.1 您在使用本服务前需要注册一个闪易帐号。闪易帐号可通过手机号码进行注册。闪易有权根据用户需求或产品需要对帐号注册和绑定的方式进行变更。",
        Urow27: "7.1.2闪易帐号的所有权归闪易公司所有，用户完成申请注册手续后，仅获得闪易帐号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖闪易帐号或者以其他方式许可非初始申请注册人使用闪易帐号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用闪易帐号。",
        Urow28: "7.1.3 用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。当在您怀疑他人在使用您的帐号时，您应立即通知闪易公司。",
        Urow29: "7.1.4用户注册闪易帐号后如果长期不登录该帐号，闪易有权回收该帐号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。",
        userCareful: "7.2 用户注意事项",
        Urow30: "7.2.1 您理解并同意：为了向您提供有效的服务，本软件会利用您终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。",
        Urow31: "7.2.2 您在使用本软件某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您接受相关单独协议。例如：如果您需要使用闪易支付相关服务（包括但不限于闪易钱包）时，需阅读并遵守《闪易支付用户服务协议》；您使用闪易支付相关服务，即视为您接受《闪易支付用户服务协议》。",
        Urow32: "7.2.3 您理解并同意闪易将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，闪易并不能就此提供完全保证，包括但不限于以下情形：",
        Urow33: "7.2.3.1 闪易不对您在本软件及服务中相关数据的删除或储存失败负责；",
        Urow34: "7.2.3.2 闪易有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本软件及服务中的相关数据；",
        Urow35: "7.2.4 如果您停止使用本软件及服务或服务被终止或取消，闪易可以从服务器上永久地删除您的数据。服务停止、终止或取消后，闪易没有义务向您返还任何数据。",
        Urow36: "7.2.5 用户在使用本软件及服务时，须自行承担如下来自闪易不可掌控的风险内容，包括但不限于：",
        Urow37: "7.2.5.1 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；",
        Urow38: "7.2.5.2 用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；",
        Urow39: "7.2.5.3 用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；",
        Urow40: "7.2.5.4 由于无线网络信号不稳定、无线网络带宽小等原因，所引起的闪易登录失败、资料同步不完整、页面打开速度慢等风险。",
        thirdService: "7.3 第三方产品和服务",
        Urow41: "7.3.1 您在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。闪易和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。",
        Urow42: "7.3.2 因用户使用本软件或要求闪易提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供（包括但不限于第三方通过闪易提供的服务，或通过开放平台接入的内容等），闪易不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与闪易无关，闪易不承担任何责任。",
        Urow43: "7.3.3 您理解并同意，闪易有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，闪易承诺在推广过程中严格按照本协议约定保护您的个人信息，同时您亦可以根据系统设置选择屏蔽、拒绝接收相关推广信息。",
        userAction: "八、用户行为规范",
        contentSpe: "8.1 信息内容规范",
        Urow44: "8.1.1 本条所述信息内容是指用户使用本软件及服务过程中所制作、复制、发布、传播的任何内容，以及其他使用闪易帐号或本软件及服务所产生的内容。",
        Urow45: "8.1.2 您理解并同意，闪易一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用闪易帐号或本软件及服务制作、复制、发布、传播如下干扰闪易正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：",
        Urow46: "8.1.2.1 发布、传送、传播、储存违反国家法律法规禁止的内容：",
        Urow47: "（1）违反宪法确定的基本原则的；",
        Urow48: "（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
        Urow49: "（3）损害国家荣誉和利益的；",
        Urow50: "（4）煽动民族仇恨、民族歧视，破坏民族团结的；",
        Urow51: "（5）破坏国家宗教政策，宣扬邪教和封建迷信的；",
        Urow52: "（6）散布谣言，扰乱社会秩序，破坏社会稳定的；",
        Urow53: "（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；",
        Urow54: "（8）侮辱或者诽谤他人，侵害他人合法权益的；",
        Urow55: "（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；",
        Urow56: "（10）以非法民间组织名义活动的；",
        Urow57: "（11）不符合《即时通信工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；",
        Urow58: "（12）含有法律、行政法规禁止的其他内容的。",
        Urow59: "8.1.2.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；",
        Urow60: "8.1.2.3 涉及他人隐私、个人信息或资料的；",
        Urow61: "8.1.2.4 发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；",
        Urow62: "8.1.2.5 其他违反法律法规、政策及公序良俗、社会公德或干扰闪易正常运营和侵犯其他用户或第三方合法权益内容的信息。",
        softwareUse: "8.2 软件使用规范",
        Urow63: "8.2.1 除非法律允许或闪易书面许可，您使用本软件过程中不得从事下列行为：",
        Urow64: "8.2.1.1 删除本软件及其副本上关于著作权的信息；",
        Urow65: "8.2.1.2 对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；",
        Urow66: "8.2.1.3 对闪易拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；",
        Urow67: "8.2.1.4 对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非闪易经授权的第三方工具/服务接入本软件和相关系统；",
        Urow68: "8.2.1.5 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；",
        Urow69: "8.2.1.6 通过非闪易开发、授权的第三方软件、插件、外挂、系统，登录或使用闪易软件及服务，或制作、发布、传播上述工具；",
        Urow70: "8.2.1.7 自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；",
        Urow71: "8.2.1.8 其他未经闪易明示授权的行为。",
        Urow72: "8.2.2 您理解并同意，基于用户体验、闪易或相关服务平台运营安全、平台规则要求及健康发展等综合因素，闪易有权选择提供服务的对象，有权决定功能设置，有权决定功能开放、数据接口和相关数据披露的对象和范围。针对以下情形，有权视具体情况中止或终止提供本服务，包括但不限于：",
        Urow73: "8.2.2.1 违反法律法规或本协议规定的；",
        Urow74: "8.2.2.2 影响服务体验的；",
        Urow75: "8.2.2.3 存在安全隐患的；",
        Urow76: "8.2.2.4 与闪易或其服务平台已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；",
        Urow77: "8.2.2.5 界面、风格、功能、描述或使用者体验与闪易或其服务平台类似，可能造成闪易用户认为其所使用的功能或服务来源于闪易或经闪易授权的；",
        Urow78: "8.2.2.6 违背闪易或其服务平台运营原则，或不符合闪易其他管理要求的。",
        Urow79: "8.3 服务运营规范",
        Urow80: "除非法律允许或闪易书面许可，您使用本服务过程中不得从事下列行为：",
        Urow81: "8.3.1 提交、发布虚假信息，或冒充、利用他人名义的；",
        Urow82: "8.3.2 诱导其他用户点击链接页面或分享信息的；",
        Urow83: "8.3.3 虚构事实、隐瞒真相以误导、欺骗他人的；",
        Urow84: "8.3.4 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；",
        Urow85: "8.3.5 未经闪易书面许可利用闪易帐号和任何功能，以及第三方运营平台进行推广或互相推广的；",
        Urow86: "8.3.6 利用闪易帐号或本软件及服务从事任何违法犯罪活动的；",
        Urow87: "8.3.7 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；",
        Urow88: "8.3.8 其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或闪易未明示授权的行为。",
        Urow89: "8.4 对自己行为负责",
        Urow90: "您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。闪易无法且不会对因前述风险而导致的任何损失或损害承担责任。",
        Urow91: "8.5 违约处理",
        Urow92: "8.5.1 如果闪易发现或收到他人举报或投诉用户违反本协议约定的，闪易有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。",
        Urow93: "8.5.2 您理解并同意，闪易有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。",
        Urow94: "8.5.3 您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；闪易因此遭受损失的，您也应当一并赔偿。",
        Urow95: "九、知识产权声明",
        Urow96: "9.1 闪易是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，闪易享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。",
        Urow97: "9.2 未经闪易或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。",
        Urow98: "十、终端安全责任",
        Urow99: "10.1 您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。",
        Urow100: "10.2 您不得制作、发布、使用、传播用于窃取闪易帐号及他人个人信息、财产的恶意程序。",
        Urow101: "10.3 维护软件安全与正常使用是闪易和您的共同责任，闪易将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意闪易并不能就此提供完全保证。",
        Urow102: "10.4 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意闪易有关防范诈骗犯罪的提示。",
        Urow103: "十一、第三方软件或技术",
        Urow104: "11.1 本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。",
        Urow105: "11.2 本软件如果使用了第三方的软件或技术，闪易将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求闪易给予协助，您应当自行承担法律责任。",
        Urow106: "11.3 如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，闪易不承担任何责任。闪易不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。",
        Urow107: "十二、其他",
        Urow108: "12.1 您使用本软件即视为您已阅读并同意受本协议的约束。闪易有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。",
        Urow109: "12.2 本协议签订地为中华人民共和国浙江省杭州市余杭区。",
        Urow110: "12.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。",
        Urow111: "12.4 若您和闪易之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。",
        Urow112: "12.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。",
        Urow113: "12.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。（正文完）"
    },
    illustrate:{
        term1: "产品名称",
        term2: "亚运智能光交互闪光吉祥物",
        term3: "产品简介",
        term4: "亚运智能光交互闪光吉祥物是一款集合了高精技术”光交互“功能的杭州2022年亚运会特许商品。它可以在指定的光交互智能硬件上进行使用，如在光交互智能存包柜上一闪存包，在光交互智能福利站上一闪领取亚运福利等。",
        term5: "产品参数",
        term6: "品类",
        term7: "玩具",
        term8: "材质",
        term9: "PVC塑胶、金属",
        term10: "规格",
        term11: "等级",
        term12: "合格品",
        term13: "适合年龄",
        term14: "3岁以上",
        term15: "电池",
        term16: "AG10型不可更换纽扣电池",
        term17: "电池使用次数高于3万次，待机时间大于2年",
        term18: "执行标准",
        term19: "产品部件",
        term20: "亚运智能闪光吉祥物",
        term21: "挂绳",
        term22: "使用说明",
        term23: "1.绑定吉祥物",
        term24: "打开支付宝,点击扫一扫,扫描上方的二维码,根据提示绑定本亚运智能闪光吉祥物并开通应用功能",
        term25: "2.触发闪光",
        term26: "按压本吉祥物左边的耳朵，可触发吉祥物眼睛闪光",
        term27: "3.与智能设备交互",
        term28: "对着设备上的圆形光接收区域，距离10cm内，按压吉祥物左耳，让光照到接受区域上，设备就会动作",
        term29: "使用场景",
        term30: "1.光交互存包柜",
        term31: "存包",
        term32: "用闪光吉祥物对准存包柜中间蓝色灯亮的圆圈按下闪光，相应编号的柜门打开，存入物品关闭柜门，灯光显示红色，存储成功。",
        term33: "取包",
        term34: "用闪光吉祥物对准存包柜中间对应编号红色亮灯的圆圈按下闪光，相应编号的柜门打开，取走物品后关好柜门，灯光显示蓝色，门已关好。",
        term35: "2.光交互福利站",
        term36: "使用闪光吉祥物对准货柜上圆点，距离5-10cm按下闪光，掉货后推开取货口拿走货物。",
        term37: "注意事项",
        term38: "1.本品含细小及尖锐部件，不适合3岁以下儿童使用；",
        term39: "2.随意丢弃产品，可能会对环境造成影响，请妥善进行回收处理；",
        term40: "3.保养时请用干布擦拭表面污渍",
    }
};

export default zh;
